import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';

import * as softlabelsActions from '../actions/soft-labels';
import { SoftLabelsHttpService } from '../services/soft-labels-http.service';
import { EntitySoftLabels } from '../models/entity-soft-labels';

@Injectable()
export class SoftLabelsEffects {

  constructor(
    private actions$: Actions,
    private softLabelsService: SoftLabelsHttpService
  ) { }

  
  load$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<softlabelsActions.Load>(softlabelsActions.LOAD),
    switchMap(() => {
      return this.softLabelsService.getEntitySoftLabels().pipe(
        map((labels: EntitySoftLabels) => new softlabelsActions.LoadComplete(labels)),
        catchError(err => of(new softlabelsActions.LoadError(err)))
      );
    })));
}
